import React from "react";
import { Title, Text, Stack, Button } from "@mantine/core";
import { PageProps } from "@sdflc/react-router-pages";
import { useNavigate } from "react-router-dom";

import { FullScreenLayout } from "@/components/layouts";
import { Logo } from "@/components/generic";

export const NotFoundPage: React.FC<PageProps> = (props: PageProps) => {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate("/");
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <FullScreenLayout justify="center" align="center" {...props}>
      <Stack gap="xl" align="center" ta="center" maw={500} px="md">
        <Logo size="large" withName />

        <Text
          size="8rem"
          style={{
            lineHeight: 1,
          }}
        >
          🧭
        </Text>

        <Stack gap="md" align="center">
          <Title order={2} c="gray.7">
            Looks Like You're Off the Map!
          </Title>
          <Text size="lg" c="dimmed" ta="center">
            This page seems to have wandered off somewhere. Don't worry - it
            happens to the best of us!
          </Text>
        </Stack>

        <Stack gap="sm" align="center" w="100%">
          <Button
            variant="filled"
            size="md"
            onClick={handleGoHome}
            fullWidth
            maw={300}
          >
            Go to Homepage
          </Button>
          <Button
            variant="outline"
            size="md"
            onClick={handleGoBack}
            fullWidth
            maw={300}
          >
            Go Back
          </Button>
        </Stack>
      </Stack>
    </FullScreenLayout>
  );
};
